<template>
    <tr>
        <td>
            {{ driver_commission_policy.pick_up_first_weight }}
        </td>
        <td>
            {{ driver_commission_policy.pick_up_first_price }}
        </td>
        <td>
            {{ driver_commission_policy.pick_up_follow_up_weight }}
        </td>
        <td>
            {{ driver_commission_policy.pick_up_follow_up_price }}
        </td>
        <td>
            {{ driver_commission_policy.delivery_first_weight }}
        </td>
        <td>
            {{ driver_commission_policy.delivery_first_price }}
        </td>
        <td>
            {{ driver_commission_policy.delivery_follow_up_weight }}
        </td>
        <td>
            {{ driver_commission_policy.delivery_follow_up_price }}
        </td>
        <td>
            {{ driver_commission_policy.house_pick_up_first_weight }}
        </td>
        <td>
            {{ driver_commission_policy.house_pick_up_first_price }}
        </td>
        <td>
            {{ driver_commission_policy.house_pick_up_follow_up_weight }}
        </td>
        <td>
            {{ driver_commission_policy.house_pick_up_follow_up_price }}
        </td>
        <td>
            {{ driver_commission_policy.house_delivery_first_weight }}
        </td>
        <td>
            {{ driver_commission_policy.house_delivery_first_price }}
        </td>
        <td>
            {{ driver_commission_policy.house_delivery_follow_up_weight }}
        </td>
        <td>
            {{ driver_commission_policy.house_delivery_follow_up_price }}
        </td>
        <td>
            <i class="ui icon check" v-if="driver_commission_policy.is_activated"></i>
            <i class="ui icon cross" v-else></i>
        </td>


        <td>
            <!-- <router-link
            :to="{name: 'edit_driver_commission_policy', params: {identity: driver_commission_policy.identity}}"
            class="ui basic primary button"
            >
                {{ $t('ui.general.edit') }}
            </router-link>
            <button class="ui basic negative button" @click.prevent="delete">{{ $t('ui.general.delete') }}</button> -->
            <button class="ui basic primary button" @click.prevent="$parent.toggle_activation(driver_commission_policy)">
                <!-- 啟用開關 -->
                {{ $t('ui.pages.driver_commission_policies.activated_switch') }}
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderDriverCommissionPoliciesIndexItem",
    props: {
        driver_commission_policy: Object
    },
    data() {
        return {
            is_processing: false,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        delete() {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                this.is_processing = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_driver_commission_policy_delete).parse(
                    {
                        "driver_commission_policy_identity": this.driver_commission_policy.identity,
                    },
                    "?authorization=" + this.$store.state.provider.node.authorization
                )

                axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                    if (response.data.status == "success") {
                        this.$parent.init()
                        // this.$noty.success("收派件提成政策刪除成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.delete__name', {
                                name: this.$t('models.driver_commission_policies')
                            })
                        )
                    } else {
                        this.$noty.error("收派件提成政策刪除失敗")
                    }
                })
                .catch(error => {
                    console.log(error)
                    if (!error.response) {
                        // Network Error
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+": "+
                            this.$t('ui.general.server_offline')
                        )
                    } else {
                        this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                    }
                })
                this.is_processing = false
            }
        },
    },
    components: {
    }
}
</script>
